import * as React from "react";
import { Routes, Route } from "react-router-dom";
import { OscillometryAnalysisListScreen } from "./OscillometryAnalysisListScreen";
import { OscillometrySessionsListScreen } from "./OscillometrySessionsListScreen";
import { OscillometryAnalysisScreen } from "./OscillometryAnalysisScreen";
import { PrivateRoute } from "../../Core/PrivateRoute";
import { PermissionEnum } from "../../misc/api/ApiPermissionEnum";

export const OscillometryRoot = () => {
    return (
        <Routes>
            <Route index element={
               <PrivateRoute permissions={[PermissionEnum.AccessSingleOscillometrySession, PermissionEnum.AccessAllOscillometrySessions, PermissionEnum.OverreadOscillometrySession]}>
                <OscillometrySessionsListScreen />
            </PrivateRoute>
            }
            />
            <Route path="/Analysis" element={
                <PrivateRoute permissions={[PermissionEnum.OverreadOscillometrySession]}>
                <OscillometryAnalysisListScreen />
            </PrivateRoute>
                }
            />
            <Route path="Analysis/:analysisSetId/:viewState" element={
                <PrivateRoute permissions={[PermissionEnum.OverreadOscillometrySession, PermissionEnum.AccessSingleOscillometrySession]}>
                <OscillometryAnalysisScreen />
                </PrivateRoute>
            }
            />
        </Routes>
    );
}
